"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingProductType = void 0;
var FundingProductType;
(function (FundingProductType) {
    FundingProductType["Insurance"] = "Insurance";
    FundingProductType["Annuity"] = "Annuity";
    FundingProductType["Trust"] = "Trust";
})(FundingProductType = exports.FundingProductType || (exports.FundingProductType = {}));
//# sourceMappingURL=funding-product-type.js.map